import { Card, CheckIcon, GKButton, GKModal, Grid2 } from "components";
import { RAWebsiteFormValues } from "interfaces/WebsiteInterface";
import { useState } from "react";
import { useFormContext } from "react-hook-form";
import { GKModalProps } from "utils/commonInterface";

const SymbolsModal = ({ open, setOpen }: GKModalProps) => {
  const form = useFormContext<RAWebsiteFormValues>();

  const [selectSymbol, setSelectSymbol] = useState(
    form.getValues("heroSectionLogo") || null,
  );

  const handleSaveSymbol = () => {
    if (selectSymbol !== null) form.setValue("heroSectionLogo", selectSymbol);
    setOpen(false);
  };

  return (
    <GKModal
      modalTitle={"Select symbol of wealth"}
      width={"466px"}
      open={open}
      setOpen={setOpen}
      closeBtn={false}
      maxHeight="calc(100vh - 292px)"
      footer={
        <GKButton
          variant="contained"
          startIcon={<CheckIcon />}
          onClick={handleSaveSymbol}
        >
          Submit
        </GKButton>
      }
    >
      <Grid2 container spacing={2}>
        {Array.from({ length: 17 }).map((_, idx) => (
          <Card
            key={idx}
            sx={{
              flex: "0 0 auto",
              borderRadius: "12px",
              p: 2,
              border:
                +selectSymbol === idx
                  ? "3px solid var(--primary-900)"
                  : "1px solid var(--neutral-100)",
              bgcolor: "var(--white)",
              width: "95px",
              height: "95px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 28,
              cursor: "pointer",
            }}
            onClick={() => setSelectSymbol(idx?.toString())}
          >
            <img
              src={`/RAWebsite/symbol-${idx}.png`}
              alt={`symbol-${idx}`}
              height={64}
              width={64}
            />
          </Card>
        ))}
      </Grid2>
    </GKModal>
  );
};

export default SymbolsModal;
